import { enableAnchorScroll } from './components/anchor.js';
import { fixedOnScroll } from './components/fixedOnScroll.js';
import { DragScroll } from './components/dragScroll.js';

// Initialize anchor scroll functionality
const anchorE = document.querySelector('.js-get-element');
if (anchorE) fixedOnScroll('#js-fixed-scroll', 0, 'anchor-fixed', anchorE.offsetTop);
enableAnchorScroll({
    elFixedHeight: 80,
    stepSpace: 128,
    selector: '.c-anchor-link a[href^="#"]',
});
document.querySelectorAll('.js-drag-scroll-link').forEach(el => new DragScroll(el, {
    activateLinks: true,
    activeClass: 'active', // class name cho link đang active
    threshold: 5
}));

